import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function YoloCashbackSixerPromoFun (props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    return (
        <>
            <InformationWrapper>
                <Container>
                     <HowToImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.yoloCBSixInnerBg}`}
                            alt="How to Join"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </HowToImageWrapper>
                </Container>
                <Container className='bgRadial morePadding'>
                    <MainTitle>How to Participate</MainTitle>
                    <HowToImageWrapper className='w-80'>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.yoloCBSixHTP}`}
                            alt="How to Join"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </HowToImageWrapper>
                </Container>
                <TermsAndCondition className={!(brandId == 33 || brandId == 34) && 'bgRadial'}>
                    <MainTitle>Terms And Conditions:</MainTitle>
                    <ul>
                        <li>Minimum qualifying bet: ₹50 on Exchange only.</li>
                        <li>Cashback applies only if the mentioned event <br /> occurs in at least one innings of the match.</li>
                        <li>Maximum cashback: ₹50 per player per day.</li>
                        <li>Valid only during Asia Cup (Sep 9 - 25, 2025).</li>
                        <li>Cashback will be credited within 24 hours..</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(YoloCashbackSixerPromoFun));

// Styled Component.
const HowToImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: auto;

    img {
        width: 100%;
        /* max-width: 100%; */
    }
`;
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 0rem 0;
    margin: 0em 1.2em  0em 1.2em;
    display: flex;
    flex-direction: column;
    background-color: #EBEBEB;
    overflow: hidden;
    border: 1px solid #bfbfbf;

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .footerText {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 120% */
        text-transform: capitalize;
        margin: 10px 0px 0px 0px;
    }

    .bgRadial {
        /* background: radial-gradient(38.26% 45.18% at 50% 0%, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 100%); */
        background: ${theme('palette.jiliPlaySpinBgRadial')};
    }

    .w-80 {
        width: 80%;
    }
`;


const Container = styled.div`
    width: 100%;
    max-width: 1366px;
    height: 40vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0;
    margin: 0 auto;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 10px;

    &.morePadding {
        padding-top: 5rem;
        padding-bottom: 3rem;
    }
`;

const MainTitle = styled.h4`
    color: #06A6FF;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    margin: 3px 0px 10px 0px;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
`

const TermsAndCondition = styled.div`
    width: 100%;
    max-width: 1366px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    padding-top: 3rem;
    background: #fff;
    border-radius: 10px;
    margin-bottom: 2rem;

    & li {
        color: #444;
        text-align: justify;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px; /* 116.667% */
        text-transform: capitalize;
        list-style-type: decimal;
        padding-bottom: 1.5rem;
    }
`;
